import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

/**
 * @description Prepare the data for the APi
 * @param Object name, default_assignees, default_priority, default_status,
 default_user_assignee_tags, default_notification_types, default_description, active
 * @return Object
 */
const handlePrepareData = ({
  name,
  default_assignees,
  default_priority,
  default_status,
  default_user_assignee_tags,
  default_notification_types,
  default_description,
  active
}) => ({
  name,
  default_assignee_id_list: default_assignees ? default_assignees.map(item => item.key || item.id) : [],
  default_priority_id: default_priority.key || default_priority.id,
  default_status_id: default_status.key || default_status.id,
  default_user_tag_id_list: default_user_assignee_tags ? default_user_assignee_tags.map(tag => tag.key || tag.id) : [],
  default_notification_type_id_list: default_notification_types.map(item => item.key || item.id),
  default_description,
  active
});

const ActionTypes = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminActions()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.actionType,
      list: REDUCER_KEY.actionTypes
    }}
    config={config}
    onPrepareData={handlePrepareData}
    permissions={permissions}
  />
);

ActionTypes.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default ActionTypes;
